import { throwErrorInline } from '../utils/throwErrorInline'

export function getAllowedClipspecOrigins(): string[] {
  const allowedOrigins = process.env.REACT_APP_CLIPSPEC_MESSAGE_ORIGIN_ALLOWLIST ?? throwErrorInline('REACT_APP_CLIPSPEC_MESSAGE_ORIGIN_ALLOWLIST not provided')
  const allowedOriginList = allowedOrigins.split(',')

  allowedOriginList.forEach(originItem => {
    if (originItem.trim().length === 0) {
      throw Error('invalid empty origin configured in allowlist')
    }
  })

  return allowedOriginList
}

export function getClipspecMessageTargetOrigin(referrerOrigin: string, originAllowlist: string[]): string {
  // special case: all origins allowed
  if (originAllowlist.includes('*')) {
    return '*'
  }

  // default case: use the document referrer if it is allowlisted
  if (referrerOrigin.length === 0) {
    throw Error('no referrer origin available')
  }

  if (!originAllowlist.includes(referrerOrigin)) {
    throw Error(`illegal origin supplied: ${referrerOrigin}`)
  }

  return referrerOrigin
}